export const DEFAULT_COUNTRY_CODE = 'ES'
